<template>
  <div class="app-main__inner">
    <TituloComponent
      icono-titulo="fas fa-pencil-alt"
      texto-titulo="Editar tipo de liquidación"
    ></TituloComponent>
    <div class="main-card mb-3 card col-12 col-md-8 offset-md-2">
      <div class="card-body">
        <form @submit.prevent="guardarTipoLiquidacion()">
          <float-label label="Descripción:" clase>
            <input
              v-model="tipoLiquidacion.descripcion"
              id="descripcion"
              placeholder="Ingresar una descripción..."
              type="text"
              class="form-control"
              :class="
                enviado && !$v.tipoLiquidacion.descripcion.required
                  ? 'is-invalid'
                  : ''
              "
            />
            <template v-slot:validation>
              <div
                class="invalid-feedback"
                v-if="enviado && !$v.tipoLiquidacion.descripcion.required"
              >
                Debe ingresar una descripción
              </div>
            </template>
          </float-label>
          <button class="mt-1 btn btn-info float-right">Guardar</button>
        </form>
      </div>
    </div>
  </div>
</template>
<script>
import TituloComponent from "@/components/layouts/TituloComponente";
import FloatLabel from "@/components/layouts/FloatLabel";
import { required } from "vuelidate/lib/validators";
import axios from "axios";
import Swal from "sweetalert2";
import TipoLiquidacion from "@/models/tipoLiquidacion";
export default {
  name: "EditarTipoLiquidacion",
  components: {
    TituloComponent,
    FloatLabel,
  },
  data() {
    return {
      tipoLiquidacion: new TipoLiquidacion(null, ""),
      loading: false,
      enviado: false,
    };
  },
  validations: {
    tipoLiquidacion: {
      descripcion: { required },
    },
  },
  mounted() {
    this.tipoLiquidacion.id = this.$route.params.id;
    this.getTipoLiquidacion();
  },
  methods: {
    getTipoLiquidacion() {
      this.loading = true;
      axios
        .get("tipoliquidacion/" + this.tipoLiquidacion.id)
        .then((res) => {
          console.log(res.data);
          if (res.data.success) {
            this.tipoLiquidacion = res.data.tipoliquidacion;
          }
        })
        .catch(() => {
          Swal.fire({
            icon: "warning",
            title: "Oopss..",
            text: `No se ha encontrado tipo de liquidación.`,
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    guardarTipoLiquidacion() {
      this.enviado = true;
      this.loading = true;
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.loading = false;
        return false;
      }
      axios
        .put(
          "/tipoliquidacion/" + this.tipoLiquidacion.id,
          this.tipoLiquidacion
        )
        .then((res) => {
          if (res.data.success) {
            Swal.fire({
              icon: "success",
              title: "Éxito",
              text: `${res.data.tipoliquidacion.descripcion} se editó con éxito.`,
            });
            this.$router.push({ name: "ListarTipoLiquidacion" });
          }
        })
        .catch((error) => {
          console.log(error);
          Swal.fire({
            icon: "error",
            title: "Oopss..",
            text: `No se ha podido completar la operación.`,
          });
        })
        .finally(() => (this.loading = false));
    },
  },
};
</script>